import styled from 'styled-components';
const AutoCompleteMLStyled = styled.div`
  div.MuiAutocomplete-inputRoot {
    height: 48px;
    div:not(:first-child):not(.MuiAutocomplete-endAdornment) {
      display: none;
    }
  }
  div.MuiAutocomplete-tag {
    text-align: right;
    height: 24px;
  }
  span.MuiAutocomplete-tag {
    display: block;
  }
  .css-1q60rmi-MuiAutocomplete-endAdornment {
    display: flex;
    .MuiIconButton-root {
      width: 24px;
      height: 24px;
    }
    .MuiSvgIcon-root {
      width: 24px;
      height: 24px;
      color: #1565c0;
    }
    .MuiAutocomplete-clearIndicator {
      .MuiSvgIcon-root {
        width: 12px;
        height: 12px;
        color: #546e7a;
      }
    }
  }
  .css-t3ycia-MuiChip-label {
    font-size: 14px;
  }
`;
export default AutoCompleteMLStyled;
